import React from "react";
import About from "./About";
import Galery from "./Galery";

const AboutHome = () => {
  return (
    <div className="about_home">
      <About />
      <Galery />
    </div>
  );
};

export default AboutHome;
